module.exports = __webpack_public_path__ + "img/ddjx.55761fd4.png";